/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import { Grid, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import React, { useCallback, useMemo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useFormState, useForm } from 'react-final-form';
import QCXFormTitle from '../form-title/QCXFormTitle';
import QCXFormStepWizard from '../../shared-components/form-step-wizard/QCXFormStepWizard';
import QCXProgressBackdrop from '../../shared-components/backdrop/QCXProgressBackdrop'

import {
  fetchMetadadosModelo,
  fetchAllOrgaosAnuentes,
  fetchListaModelosOrgao,
  fetchMetadadosFormularioNcmModelo,
} from "../../features/lpco/lpcoMicroApi"

import {startLoading, finishLoading} from "../../features/application-state/applicationStateSlice";

import LpcoDynamicFields from '../lpco-dynamic-fields/LpcoDynamicFields';

import OrgaosAnuentesField from './components/OrgaosAnuentesField';
import ModelosLpcosOrgaoField from './components/ModelosLpcosOrgaoField';


export default function QCXLicencaImportacaoBasicasFormLPCOStepWizard({
  values,
  isConsult,
  isLocked,
  ...restProps
}) {

    const form = useForm();
    const dispatch = useDispatch();
    const { t } = useTranslation();  
    const [metadadosLpco, setMetadadosLpco] = useState(null);
    const [orgaosAnuentes, setOrgaosAnuentes] = useState([]);
    const [listaModelosLpcosOrgao, setListaModelosLpcosOrgao] = useState([]);
    const [metadadosNcmModelo, setMetadadosNcmModelo] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
  
    const [orgaoAnuenteSelecionado, setOrgaoAnuenteSelecionado] = useState(null);
    const [modeloLpcoOrgaoSelecionado, setModeloLpcoOrgaoSelecionado] = useState(null);
    const [codigoModeloAnterior, setCodigoModeloAnterior] = useState(null);

    const [ncmsLpco, setNcmsLpco] = useState([]);
  
    useEffect(() => {
      getOrgaosAnuentes();
    }, [])

    const getOrgaosAnuentes = async () => {
      try {

        setIsLoading(true);
        const response = await fetchAllOrgaosAnuentes();
        setIsLoading(false);

        if (response.status !== 200) {
          return ;
        }
        
        setOrgaosAnuentes(response.data);
      } catch (error) {
        setIsLoading(false);
        console.error('Error fetching lista modelos lpco:', error);
      }
    }


    useEffect(() => {
      
      // atualiza array de ncms apenas se mudar nos values do formik
      const mercadorias = _.get(values, "mercadorias", []);

      const newNcms = mercadorias
        .map(m => _.get(m, 'ncm.code'))
        .filter(Boolean)
        .sort();


      const currentNcms = [...(ncmsLpco || [])].sort();

      const newStr = newNcms.join(',');
      const currentStr = currentNcms.join(',');

      // nao atualiza o estado de ncmsLpco caso nao tenha atualizacao de mercadoria
      if (newStr === currentStr) return;
      
      setNcmsLpco(newNcms);
      
    }, [values])

    useEffect(() => {

      if (!ncmsLpco || ncmsLpco.length === 0) return ;
      if (!orgaoAnuenteSelecionado) return ;
      if (!modeloLpcoOrgaoSelecionado) return ;

      getMetadadosFormularioNcmModelo(modeloLpcoOrgaoSelecionado, ncmsLpco);
    }, [ncmsLpco, modeloLpcoOrgaoSelecionado])

    const getMetadadosFormularioNcmModelo = async (modelo, ncms) => {
      try {
        setIsLoading(true);
        const response = await fetchMetadadosFormularioNcmModelo(modelo, ncms[0])
        setIsLoading(false);
        if (response.status !== 200) {
          return ;
        }
        
        setMetadadosNcmModelo(response.data);
      } catch (error) {
        setIsLoading(false);
        console.error('Error fetching lista modelos lpco:', error);
      }
    }


   

    useEffect(() => {
      const idOrgao = _.get(values, "atributosAdicionais.lpcoForm.orgaoAnuenteCode", null);

      if (idOrgao && idOrgao !== orgaoAnuenteSelecionado) {
        setOrgaoAnuenteSelecionado(idOrgao);
      }

      const modeloLpcoId = _.get(values, "atributosAdicionais.lpcoForm.modeloCode", null);
      if (modeloLpcoId && modeloLpcoId !== modeloLpcoOrgaoSelecionado) {
        setModeloLpcoOrgaoSelecionado(modeloLpcoId);
      }

    }, [values])
  
    useEffect(() => {
      if (!orgaoAnuenteSelecionado) return ;

      getListaModelosOrgaoAnuente(orgaoAnuenteSelecionado);

    }, [orgaoAnuenteSelecionado])

    const getListaModelosOrgaoAnuente = async (idOrgao) => {
      try {
        
        setIsLoading(true);
        const response = await fetchListaModelosOrgao(idOrgao);
        setIsLoading(false);

        if (response.status !== 200) {
          return ;
        }

        const arrModelos = response?.data?.filter(el => el.codigo.startsWith("I"))
        
        setListaModelosLpcosOrgao(arrModelos);
      } catch (error) {
        setIsLoading(false);
        console.error('Error fetching lista modelos lpco:', error);
      }
    }

    useEffect(() => {
      if (!modeloLpcoOrgaoSelecionado) return ;

      if (codigoModeloAnterior && codigoModeloAnterior !== modeloLpcoOrgaoSelecionado) {
        const pathForm = "atributosAdicionais.lpcoForm.jsonFormulario"
        form.change(pathForm, {});
      }

      setCodigoModeloAnterior(modeloLpcoOrgaoSelecionado);
      getMetadadosModeloLpco(modeloLpcoOrgaoSelecionado);

    }, [modeloLpcoOrgaoSelecionado])

    const getMetadadosModeloLpco = async (modeloId) => {
      try {
        setIsLoading(true);
        const response = await fetchMetadadosModelo(modeloId);
        setIsLoading(false);
        if (response.status !== 200) {
          return ;
        }
        
        setMetadadosLpco(response.data);
      } catch (error) {
        setIsLoading(false);
        console.error('Error fetching lista modelos lpco:', error);
      }
    }

  return (
    <>

    <Grid container spacing={2} style={{ marginTop: '1rem' }}>
      <Grid item xs={12} sm={6} md={4}>
        <OrgaosAnuentesField
          orgaosAnuentes={orgaosAnuentes}
          setOrgaoAnuenteSelecionado={setOrgaoAnuenteSelecionado}
          isConsult={isConsult}
        />
      </Grid>

      {
        listaModelosLpcosOrgao && _.isArray(listaModelosLpcosOrgao) && listaModelosLpcosOrgao.length > 0 && (
          <Grid item xs={12} sm={6} md={4}>
            <ModelosLpcosOrgaoField
              listaModelos={listaModelosLpcosOrgao}
              isConsult={isConsult}
            />
          </Grid>
        )
      }
    </Grid>


        
      <QCXFormTitle title={t('com.muralis.qcx.fichaBasicas')} />
      
      <Grid container spacing={2} style={{ marginTop: '1rem' }}>

        {
          metadadosLpco?.listaCamposFormulario?.map(metadado => (<LpcoDynamicFields metadado={metadado} isConsult={isConsult}/>))
        }
      </Grid>

      <QCXFormTitle title="Atributos de NCM" />
      
      <Grid container spacing={2} style={{ marginTop: '1rem' }}>

        {
          metadadosNcmModelo?.listaCamposNcm?.map(metadado => (<LpcoDynamicFields metadado={metadado} isConsult={isConsult} ncm/>))
        }
      </Grid>

      
      <QCXProgressBackdrop open={isLoading} />
      
    </>
  );
}